export const COLORS = {
  light: {
    axis: "#666666",
    grid: "#e5e7eb",
    textColor: "#333333",
  },
  dark: {
    axis: "#cccccc",
    grid: "#374151",
    textColor: "#ffffff",
  },
};

export const DATE_FORMAT = "MMM d, yyyy";

interface TrendClasses {
  containerBg: string;
  iconType: string;
  textClass?: string;
}

export const TREND_POSITIVE_CLASSES: TrendClasses = {
  containerBg: "bg-v2-success-100",
  textClass: "text-green-success-dark",
  iconType: "12-arrow-up",
};

export const TREND_NEGATIVE_CLASSES: TrendClasses = {
  containerBg: "bg-warning-light",
  // Use DS token via class to avoid inline styles
  textClass: "text-[var(--base-amber-700,#B45309)]",
  iconType: "12-arrow-down",
};
